<template>
    <div class="scroll-inner">
        <Timeline class="timeline-default timestamp-left mt-10">
            <TimelineItem
            v-for="(event, id) in timelineDetails"
            :key="id"
            placement="top"
            :class="getClassOfMessage(event)"
            >
            <div class="el-timeline-item__timestamp is-top">
                <span class="date">{{ event.date }}</span>
                <span>{{ event.time }}</span>
            </div>
            <div v-if="event.type === 'destination' && Array.isArray(event.message)">
                <h4 v-for="(city, index) in event.message" :key="index">
                <span> - {{ city }}</span>
                </h4>
            </div>
            <h4 v-else>
                {{ event.message }}
            </h4>
            <p v-if="event.type === 'invoice_custom'">
              <span v-if="event.label">{{ event.label }} - </span> {{ event.userName }}
            </p>
            <p v-else-if="event.label">
                {{ event.label }}
            </p>
            <p v-else-if="event.userName && timelineToShowUsers.includes(event.type)">
                {{ event.userName }}
            </p>
            </TimelineItem>
        </Timeline>
    </div>
</template>
<script>
import { timelineToShowUsers } from '@common/constants/timelineConstants';

export default {
  name: 'timeline-details',
  data() {
    return {
      timelineToShowUsers,
    };
  },
  props: {
    timelineDetails: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getClassOfMessage(event) {
      if (event.type === 'payment_removed') {
        return 'dot-red';
      } else if (event.type === 'destination') {
        return 'dot-green';
      } else if (event.message === 'reported at') {
        return 'dot-blue';
      }
      return 'dot-purple';
    },
  },
};
</script>
